import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import React from "react";

const Comments = () => {
  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  return (
    <>
      <h2>{t('texts.kommentare.title')}</h2>
      <div>
        <p dangerouslySetInnerHTML={{__html: t('texts.kommentare.text')}} />
      </div>
      <div style={{ align: "center" }}>
        <iframe src={(lang === "de") ? 
          "https://docs.google.com/forms/d/e/1FAIpQLSfaMPX12tHA7A2NsEI0qah5WSVrMm5Pp4_yNwfAygTd1MMS_g/viewform?embedded=true" : 
          "https://docs.google.com/forms/d/e/1FAIpQLSftEVV09B0bGDy6DgBKDmunJKQtHvUd41yYHSpy2Ouv0I9Mfg/viewform?embedded=true"} 
          width="95%" height="1000" frameBorder="0" marginHeight="0" marginWidth="0" title="Comments">Loading…</iframe>
        <iframe src="" width="640" height="2245" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </div>
    </>
  )
};

export default Comments;